import React, { useState, useEffect } from "react";
import ScratchShimmerLoader from "./ScratchShimmerLoader";

const ScratchJrWorkspace = ({
  mode = "free_play", // "free_play" | "daily_practice" | "competition"
  initialData = null,
  selectedChild = null,
  readOnly = false,
  onGradeSubmit = null,
}) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Safety fallback timer for shimmer transition
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 3500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="w-full h-full bg-slate-900 overflow-hidden relative flex flex-col">
      <ScratchShimmerLoader
        title="Practido Junior Code Studio"
        subTitle="Preparing your interactive junior block studio"
        isLoaded={isLoaded}
      />

      <iframe
        title="Practido Junior Code Studio"
        src="/scratchjr/index.html"
        loading="eager"
        onLoad={() => setIsLoaded(true)}
        className="w-full h-full border-0 block flex-1"
        allow="fullscreen; autoplay"
      />
    </div>
  );
};

export default ScratchJrWorkspace;

